import { useEffect, useState } from 'react'

interface Time {
  days: string
  hours: string
  minutes: string
  seconds: string
}

const useCountDown = ({ endTime = '' }: { endTime?: string }) => {
  const [time, setTime] = useState<Time>({
    days: '00',
    hours: '00',
    minutes: '00',
    seconds: '00',
  })

  useEffect(() => {
    const format = (date: number) => {
      const number = date < 0 ? 0 : Math.floor(date)
      return number.toString().padStart(2, '0')
    }

    // 确保 ISO 格式字符串以 UTC 方式解析（与 Banner 的 CountdownByEndDate 行为一致）
    // 无时区信息的 ISO 字符串（如 "2025-12-31T23:59:59"）默认按本地时区解析，会导致时区敏感
    // 添加 Z 后缀强制按 UTC 解析，已有时区信息（Z、+08:00 等）的字符串不受影响
    const hasTimezone = /Z$|[+-]\d{2}:?\d{2}$/.test(endTime)
    const normalizedEndTime = endTime && !hasTimezone ? `${endTime}Z` : endTime
    const countDownDate = new Date(normalizedEndTime).getTime()

    const timer = setInterval(() => {
      const now = new Date().getTime()
      const distance = countDownDate - now

      const days = format(distance / (1000 * 60 * 60 * 24))
      const hours = format((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = format((distance % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = format((distance % (1000 * 60)) / 1000)

      setTime({
        days,
        hours,
        minutes,
        seconds,
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [endTime])

  return time
}

export default useCountDown
